export default __webpack_public_path__ + "static/media/lotto1.1b7c43d4.jpg";